<div id="dropZone"  [className]="customstyle" [class.over]="dragoverflag"
    (drop)="dropFiles($event)"
    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
    <div class="content">
        <ng-content></ng-content>
        {{headertext}}
    </div>
</div>
